import "./EditTeamMember.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditTeamMemberComponentController from "./EditTeamMemberComponentController";

export default class EditTeamMemberComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditTeamMemberComponentController;
        this.templateUrl = "/App/Components/Team/EditTeamMember/EditTeamMember.html";
    }
}

module("mmManagePortal").component("mmEditTeamMember", new EditTeamMemberComponent());
